import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroOmaggiModalComponent } from './worker-registro-omaggi-modal';

export const WorkerRegistroOmaggiModalModule: string = ng
    .module('worker-registro-omaggi-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroOmaggiModalComponent', WorkerRegistroOmaggiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-omaggi-modal/worker-registro-omaggi-modal.module.ts